<template>
  <div class="drawer_panel-overlay" :class="[{'disabled': overlayDisabled}, {'open': open}]" @click="closeDrawer()">
    <div class="drawer-panel" :class="[position, {'open': open}]" @click.stop="">
      <div class="drawer_panel-header">
        <span>{{ title }}</span>
        <button class="drawer_panel-close" @click="closeDrawer()"><span class="circle"></span></button>
      </div>
      <div class="drawer_panel-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DrawerPanel',
  props: {
    title: String,
    id: {
      type: String,
      required: true
    },
    noOverlay: {
      type: String,
      default: 'false'
    },
    position: {
      type: String,
      default: 'right'
    }
  },
  data: () => {
    return {
      overlayDisabled: false, // true: If need to interact with page
      open: false
    }
  },
  methods: {
    openDrawer: function() {
      this.open = true
    },
    closeDrawer: function() {
      this.open = false

      const eventDetails = {
        'id': this.id
      }
      const eventDrawerPanelClosed = new CustomEvent('drawerPanelClosed', {'detail': eventDetails})
      document.dispatchEvent(eventDrawerPanelClosed)
    }
  },
  created: function() {
    // Add event listener
    document.addEventListener('drawerPanelOpen', (e) => {
      if(this.id == e.detail.id) {
        this.openDrawer()
      }
    })
    document.addEventListener('drawerPanelClose', (e) => {
      if(this.id == e.detail.id) {
        this.closeDrawer()
      }
    })
    document.addEventListener('drawerPanelToggle', (e) => {
      if(this.id == e.detail.id) {
        this.open = !this.open
      }
    })

    // manage overlay
    this.overlayDisabled = (this.noOverlay == "true")
  }
}
</script>

<style lang="scss" scoped>
  @import "~bootstrap/scss/bootstrap";
  @import '~bootstrap/scss/mixins/breakpoints';

  .drawer_panel-overlay {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    opacity: 0;
    // transition: opacity 0.4s;

    &.open {
      opacity: 1;
    }

    &.open:not(.disabled) {
      pointer-events: all;
      background-color: rgba(0, 0, 0, 0.2);
    }
  }

  .drawer-panel {
    width: 400px;
    height: 100%;
    position: absolute;
    top: 0;
    background-color: #FFF;
    box-shadow: -5px 0px 15px -5px rgba(0, 0, 0, 0.2);
    pointer-events: all;
    transition: right 0.4s cubic-bezier(0.2, 1, 0.2, 1), left 0.4s cubic-bezier(0.2, 1, 0.2, 1);

    // close position
    &.right {
      right: -450px;
    }
    &.left {
      left: -450px;
    }

    @include media-breakpoint-down(sm) {
      width: 95%;
    }

    // open position
    &.open {
      &.right {
        right: 0;
      }
      &.left {
        left: 0;
      }
    }

    .drawer_panel-header {
      display: flex;
      padding: 15px;
      align-items: center;
      justify-content: space-between;
      font-size: 1.5rem;
    }
    .drawer_panel-close {
      display: block;
      width: 40px;
      height: 40px;
      position: relative;
      padding: 5px;
      background: none;
      border: none;
      transition: transform 200ms;

      &:hover {
        .circle {
          transform: translate(-50%, -50%) scale(1);
          opacity: 1;
        }
      }

      &:active,
      &:focus {
        outline: none;
      }
      &:active {
        transform: scale(0.8);

        .circle {
          opacity: 0.1;
        }
      }

      &::before,
      &::after {
        content: '';
        display: block;
        width: 2px;
        height: 65%;
        position: absolute;
        left: 50%;
        top: 50%;
        background-color: #000;
      }
      &::before {
        transform: translate(-50%, -50%) rotate(-45deg);
      }
      &::after {
        transform: translate(-50%, -50%) rotate(45deg);
      }

      .circle {
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        background-color: rgba(50, 50, 50, 0.1);
        transform: translate(-50%, -50%) scale(0.75);
        opacity: 0;
        transition: transform 100ms, opacity .2s;
      }
    } // END: Btn close

    .drawer_panel-content {
      padding: 15px;
    }
  }
</style>